import { render, staticRenderFns } from "./WorkDetailsModal.vue?vue&type=template&id=2510825a&scoped=true&"
import script from "./WorkDetailsModal.vue?vue&type=script&lang=js&"
export * from "./WorkDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetailsModal.vue?vue&type=style&index=0&id=2510825a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510825a",
  null
  
)

export default component.exports